// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: common.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "com.anko.darwin";

/** Chat message types for structured conversations */
export enum ChatMessageType {
  UNKNOWN_MESSAGE_TYPE = 0,
  SYSTEM = 1,
  HUMAN = 2,
  REASONING = 3,
  RESPONSE = 4,
  CONTEXT = 5,
  UNRECOGNIZED = -1,
}

export function chatMessageTypeFromJSON(object: any): ChatMessageType {
  switch (object) {
    case 0:
    case "UNKNOWN_MESSAGE_TYPE":
      return ChatMessageType.UNKNOWN_MESSAGE_TYPE;
    case 1:
    case "SYSTEM":
      return ChatMessageType.SYSTEM;
    case 2:
    case "HUMAN":
      return ChatMessageType.HUMAN;
    case 3:
    case "REASONING":
      return ChatMessageType.REASONING;
    case 4:
    case "RESPONSE":
      return ChatMessageType.RESPONSE;
    case 5:
    case "CONTEXT":
      return ChatMessageType.CONTEXT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatMessageType.UNRECOGNIZED;
  }
}

export function chatMessageTypeToJSON(object: ChatMessageType): string {
  switch (object) {
    case ChatMessageType.UNKNOWN_MESSAGE_TYPE:
      return "UNKNOWN_MESSAGE_TYPE";
    case ChatMessageType.SYSTEM:
      return "SYSTEM";
    case ChatMessageType.HUMAN:
      return "HUMAN";
    case ChatMessageType.REASONING:
      return "REASONING";
    case ChatMessageType.RESPONSE:
      return "RESPONSE";
    case ChatMessageType.CONTEXT:
      return "CONTEXT";
    case ChatMessageType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Sort field options for list APIs */
export enum SortBy {
  UNKNOWN_SORT_BY = 0,
  CREATED_DATE = 1,
  LAST_MODIFIED_DATE = 2,
  NAME = 3,
  UNRECOGNIZED = -1,
}

export function sortByFromJSON(object: any): SortBy {
  switch (object) {
    case 0:
    case "UNKNOWN_SORT_BY":
      return SortBy.UNKNOWN_SORT_BY;
    case 1:
    case "CREATED_DATE":
      return SortBy.CREATED_DATE;
    case 2:
    case "LAST_MODIFIED_DATE":
      return SortBy.LAST_MODIFIED_DATE;
    case 3:
    case "NAME":
      return SortBy.NAME;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortBy.UNRECOGNIZED;
  }
}

export function sortByToJSON(object: SortBy): string {
  switch (object) {
    case SortBy.UNKNOWN_SORT_BY:
      return "UNKNOWN_SORT_BY";
    case SortBy.CREATED_DATE:
      return "CREATED_DATE";
    case SortBy.LAST_MODIFIED_DATE:
      return "LAST_MODIFIED_DATE";
    case SortBy.NAME:
      return "NAME";
    case SortBy.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Sort order options for list APIs */
export enum SortOrder {
  UNKNOWN_SORT_ORDER = 0,
  ASC = 1,
  DESC = 2,
  UNRECOGNIZED = -1,
}

export function sortOrderFromJSON(object: any): SortOrder {
  switch (object) {
    case 0:
    case "UNKNOWN_SORT_ORDER":
      return SortOrder.UNKNOWN_SORT_ORDER;
    case 1:
    case "ASC":
      return SortOrder.ASC;
    case 2:
    case "DESC":
      return SortOrder.DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SortOrder.UNRECOGNIZED;
  }
}

export function sortOrderToJSON(object: SortOrder): string {
  switch (object) {
    case SortOrder.UNKNOWN_SORT_ORDER:
      return "UNKNOWN_SORT_ORDER";
    case SortOrder.ASC:
      return "ASC";
    case SortOrder.DESC:
      return "DESC";
    case SortOrder.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Experiment Status */
export enum ExperimentStatus {
  UNKNOWN_STATUS = 0,
  PENDING = 1,
  PROCESSING = 2,
  COMPLETED = 3,
  FAILED = 4,
  UNRECOGNIZED = -1,
}

export function experimentStatusFromJSON(object: any): ExperimentStatus {
  switch (object) {
    case 0:
    case "UNKNOWN_STATUS":
      return ExperimentStatus.UNKNOWN_STATUS;
    case 1:
    case "PENDING":
      return ExperimentStatus.PENDING;
    case 2:
    case "PROCESSING":
      return ExperimentStatus.PROCESSING;
    case 3:
    case "COMPLETED":
      return ExperimentStatus.COMPLETED;
    case 4:
    case "FAILED":
      return ExperimentStatus.FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExperimentStatus.UNRECOGNIZED;
  }
}

export function experimentStatusToJSON(object: ExperimentStatus): string {
  switch (object) {
    case ExperimentStatus.UNKNOWN_STATUS:
      return "UNKNOWN_STATUS";
    case ExperimentStatus.PENDING:
      return "PENDING";
    case ExperimentStatus.PROCESSING:
      return "PROCESSING";
    case ExperimentStatus.COMPLETED:
      return "COMPLETED";
    case ExperimentStatus.FAILED:
      return "FAILED";
    case ExperimentStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Darwin Agent Type enum */
export enum DarwinAgentType {
  UNKNOWN_AGENT_TYPE = 0,
  CUSTOM = 1,
  TREE_SCHEMA_AGENT = 2,
  MULTI_TREE_SCHEMA_AGENT = 3,
  ADD_NUMBERS_TOOL_AGENT = 4,
  DATA_SCOPE_AGENT = 5,
  SCENARIO_AGENT = 6,
  ANALYST_CHAT_AGENT = 7,
  SCENARIO_SYNTHESIS_AGENT = 8,
  SCENARIO_CREATION_AGENT = 9,
  CHAT_NAMING_AGENT = 10,
  UNRECOGNIZED = -1,
}

export function darwinAgentTypeFromJSON(object: any): DarwinAgentType {
  switch (object) {
    case 0:
    case "UNKNOWN_AGENT_TYPE":
      return DarwinAgentType.UNKNOWN_AGENT_TYPE;
    case 1:
    case "CUSTOM":
      return DarwinAgentType.CUSTOM;
    case 2:
    case "TREE_SCHEMA_AGENT":
      return DarwinAgentType.TREE_SCHEMA_AGENT;
    case 3:
    case "MULTI_TREE_SCHEMA_AGENT":
      return DarwinAgentType.MULTI_TREE_SCHEMA_AGENT;
    case 4:
    case "ADD_NUMBERS_TOOL_AGENT":
      return DarwinAgentType.ADD_NUMBERS_TOOL_AGENT;
    case 5:
    case "DATA_SCOPE_AGENT":
      return DarwinAgentType.DATA_SCOPE_AGENT;
    case 6:
    case "SCENARIO_AGENT":
      return DarwinAgentType.SCENARIO_AGENT;
    case 7:
    case "ANALYST_CHAT_AGENT":
      return DarwinAgentType.ANALYST_CHAT_AGENT;
    case 8:
    case "SCENARIO_SYNTHESIS_AGENT":
      return DarwinAgentType.SCENARIO_SYNTHESIS_AGENT;
    case 9:
    case "SCENARIO_CREATION_AGENT":
      return DarwinAgentType.SCENARIO_CREATION_AGENT;
    case 10:
    case "CHAT_NAMING_AGENT":
      return DarwinAgentType.CHAT_NAMING_AGENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DarwinAgentType.UNRECOGNIZED;
  }
}

export function darwinAgentTypeToJSON(object: DarwinAgentType): string {
  switch (object) {
    case DarwinAgentType.UNKNOWN_AGENT_TYPE:
      return "UNKNOWN_AGENT_TYPE";
    case DarwinAgentType.CUSTOM:
      return "CUSTOM";
    case DarwinAgentType.TREE_SCHEMA_AGENT:
      return "TREE_SCHEMA_AGENT";
    case DarwinAgentType.MULTI_TREE_SCHEMA_AGENT:
      return "MULTI_TREE_SCHEMA_AGENT";
    case DarwinAgentType.ADD_NUMBERS_TOOL_AGENT:
      return "ADD_NUMBERS_TOOL_AGENT";
    case DarwinAgentType.DATA_SCOPE_AGENT:
      return "DATA_SCOPE_AGENT";
    case DarwinAgentType.SCENARIO_AGENT:
      return "SCENARIO_AGENT";
    case DarwinAgentType.ANALYST_CHAT_AGENT:
      return "ANALYST_CHAT_AGENT";
    case DarwinAgentType.SCENARIO_SYNTHESIS_AGENT:
      return "SCENARIO_SYNTHESIS_AGENT";
    case DarwinAgentType.SCENARIO_CREATION_AGENT:
      return "SCENARIO_CREATION_AGENT";
    case DarwinAgentType.CHAT_NAMING_AGENT:
      return "CHAT_NAMING_AGENT";
    case DarwinAgentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Darwin Agent Reasoning Effort Level */
export enum ReasoningEffortLevel {
  /**
   * REASONING_NOT_VALID - TODO: add support for non-OpenAI models later
   * Reasoning effort is not set for the model
   */
  REASONING_NOT_VALID = 0,
  /** NONE - Reasoning model will not do reasoning */
  NONE = 1,
  /** MINIMAL - Reasoning model will do minimal level reasoning */
  MINIMAL = 2,
  /** LOW - Reasoning model will do low level reasoning */
  LOW = 3,
  /** MEDIUM - Reasoning model will do medium level reasoning */
  MEDIUM = 4,
  /** HIGH - Reasoning model will do high level reasoning */
  HIGH = 5,
  /** XHIGH - Reasoning model will do extremely high level reasoning - introduced with 5.2 openai model */
  XHIGH = 6,
  UNRECOGNIZED = -1,
}

export function reasoningEffortLevelFromJSON(object: any): ReasoningEffortLevel {
  switch (object) {
    case 0:
    case "REASONING_NOT_VALID":
      return ReasoningEffortLevel.REASONING_NOT_VALID;
    case 1:
    case "NONE":
      return ReasoningEffortLevel.NONE;
    case 2:
    case "MINIMAL":
      return ReasoningEffortLevel.MINIMAL;
    case 3:
    case "LOW":
      return ReasoningEffortLevel.LOW;
    case 4:
    case "MEDIUM":
      return ReasoningEffortLevel.MEDIUM;
    case 5:
    case "HIGH":
      return ReasoningEffortLevel.HIGH;
    case 6:
    case "XHIGH":
      return ReasoningEffortLevel.XHIGH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ReasoningEffortLevel.UNRECOGNIZED;
  }
}

export function reasoningEffortLevelToJSON(object: ReasoningEffortLevel): string {
  switch (object) {
    case ReasoningEffortLevel.REASONING_NOT_VALID:
      return "REASONING_NOT_VALID";
    case ReasoningEffortLevel.NONE:
      return "NONE";
    case ReasoningEffortLevel.MINIMAL:
      return "MINIMAL";
    case ReasoningEffortLevel.LOW:
      return "LOW";
    case ReasoningEffortLevel.MEDIUM:
      return "MEDIUM";
    case ReasoningEffortLevel.HIGH:
      return "HIGH";
    case ReasoningEffortLevel.XHIGH:
      return "XHIGH";
    case ReasoningEffortLevel.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Enum for artifact type */
export enum ArtifactType {
  UNKNOWN_ARTIFACT_TYPE = 0,
  KG_OBSERVATION = 1,
  KG_DATAFRAME = 2,
  SCENARIO = 3,
  ANALYST_JOB_RUN = 4,
  SCENARIO_JOB = 5,
  ANALYSIS_OUTPUT = 6,
  DATAFRAME_ANALYSIS = 7,
  FILE_ARTIFACT = 8,
  WORKFLOW_RUN = 9,
  WORKFLOW_RUN_SEARCH = 10,
  UNRECOGNIZED = -1,
}

export function artifactTypeFromJSON(object: any): ArtifactType {
  switch (object) {
    case 0:
    case "UNKNOWN_ARTIFACT_TYPE":
      return ArtifactType.UNKNOWN_ARTIFACT_TYPE;
    case 1:
    case "KG_OBSERVATION":
      return ArtifactType.KG_OBSERVATION;
    case 2:
    case "KG_DATAFRAME":
      return ArtifactType.KG_DATAFRAME;
    case 3:
    case "SCENARIO":
      return ArtifactType.SCENARIO;
    case 4:
    case "ANALYST_JOB_RUN":
      return ArtifactType.ANALYST_JOB_RUN;
    case 5:
    case "SCENARIO_JOB":
      return ArtifactType.SCENARIO_JOB;
    case 6:
    case "ANALYSIS_OUTPUT":
      return ArtifactType.ANALYSIS_OUTPUT;
    case 7:
    case "DATAFRAME_ANALYSIS":
      return ArtifactType.DATAFRAME_ANALYSIS;
    case 8:
    case "FILE_ARTIFACT":
      return ArtifactType.FILE_ARTIFACT;
    case 9:
    case "WORKFLOW_RUN":
      return ArtifactType.WORKFLOW_RUN;
    case 10:
    case "WORKFLOW_RUN_SEARCH":
      return ArtifactType.WORKFLOW_RUN_SEARCH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ArtifactType.UNRECOGNIZED;
  }
}

export function artifactTypeToJSON(object: ArtifactType): string {
  switch (object) {
    case ArtifactType.UNKNOWN_ARTIFACT_TYPE:
      return "UNKNOWN_ARTIFACT_TYPE";
    case ArtifactType.KG_OBSERVATION:
      return "KG_OBSERVATION";
    case ArtifactType.KG_DATAFRAME:
      return "KG_DATAFRAME";
    case ArtifactType.SCENARIO:
      return "SCENARIO";
    case ArtifactType.ANALYST_JOB_RUN:
      return "ANALYST_JOB_RUN";
    case ArtifactType.SCENARIO_JOB:
      return "SCENARIO_JOB";
    case ArtifactType.ANALYSIS_OUTPUT:
      return "ANALYSIS_OUTPUT";
    case ArtifactType.DATAFRAME_ANALYSIS:
      return "DATAFRAME_ANALYSIS";
    case ArtifactType.FILE_ARTIFACT:
      return "FILE_ARTIFACT";
    case ArtifactType.WORKFLOW_RUN:
      return "WORKFLOW_RUN";
    case ArtifactType.WORKFLOW_RUN_SEARCH:
      return "WORKFLOW_RUN_SEARCH";
    case ArtifactType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Supported file types for uploaded file artifacts */
export enum FileType {
  UNKNOWN_FILE_TYPE = 0,
  CSV = 1,
  CHART_SPEC_JSON = 2,
  DOCX = 3,
  PDF = 4,
  PNG = 5,
  JPEG = 6,
  UNRECOGNIZED = -1,
}

export function fileTypeFromJSON(object: any): FileType {
  switch (object) {
    case 0:
    case "UNKNOWN_FILE_TYPE":
      return FileType.UNKNOWN_FILE_TYPE;
    case 1:
    case "CSV":
      return FileType.CSV;
    case 2:
    case "CHART_SPEC_JSON":
      return FileType.CHART_SPEC_JSON;
    case 3:
    case "DOCX":
      return FileType.DOCX;
    case 4:
    case "PDF":
      return FileType.PDF;
    case 5:
    case "PNG":
      return FileType.PNG;
    case 6:
    case "JPEG":
      return FileType.JPEG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FileType.UNRECOGNIZED;
  }
}

export function fileTypeToJSON(object: FileType): string {
  switch (object) {
    case FileType.UNKNOWN_FILE_TYPE:
      return "UNKNOWN_FILE_TYPE";
    case FileType.CSV:
      return "CSV";
    case FileType.CHART_SPEC_JSON:
      return "CHART_SPEC_JSON";
    case FileType.DOCX:
      return "DOCX";
    case FileType.PDF:
      return "PDF";
    case FileType.PNG:
      return "PNG";
    case FileType.JPEG:
      return "JPEG";
    case FileType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Execution status type */
export enum ExecutionStatusType {
  IDLE_STATE = 0,
  EXECUTING_LLM_CALL = 1,
  EXECUTING_TOOL_CALL = 2,
  ERROR_STATE = 3,
  SUCCESS = 4,
  VALIDATING_TOOL_CALL = 5,
  TOOL_CALL_SUCCESS = 6,
  TOOL_CALL_FAILURE = 7,
  BUILDING_DATAFRAME = 8,
  VALIDATING_DATAFRAME = 9,
  EXECUTING_DATAFRAME = 10,
  FETCHING_PAST_JOB_RUNS = 11,
  FETCHING_SCENARIO_DETAIL = 12,
  LOADING_SCENARIO_MANAGEMENT_SKILL = 13,
  LOADING_SCENARIO_SYNTHESIS_SKILL = 14,
  UPDATING_SCENARIO_METADATA = 15,
  BUILDING_KG_OBSERVATION = 16,
  EXECUTING_KG_OBSERVATION = 17,
  SAVING_SCENARIO = 18,
  BUILDING_ANALYSIS_OUTPUT = 19,
  FETCHING_ANALYSIS_OUTPUT = 20,
  ANALYZING_DATAFRAMES = 21,
  CREATING_DATAFRAME_ANALYSIS = 22,
  EXECUTING_DATAFRAME_ANALYSIS = 23,
  LOADING_SKILL = 24,
  BUILDING_CHART = 25,
  CREATING_SCENARIO_METADATA = 26,
  BUILDING_REPORT = 27,
  REASONING_SUMMARY = 28,
  CREATING_FILE_ARTIFACT = 29,
  SEARCHING_WORKFLOW_RUNS = 30,
  SAVING_WORKFLOW_RUN = 31,
  LOADING_WORKFLOW_RUN = 32,
  UNRECOGNIZED = -1,
}

export function executionStatusTypeFromJSON(object: any): ExecutionStatusType {
  switch (object) {
    case 0:
    case "IDLE_STATE":
      return ExecutionStatusType.IDLE_STATE;
    case 1:
    case "EXECUTING_LLM_CALL":
      return ExecutionStatusType.EXECUTING_LLM_CALL;
    case 2:
    case "EXECUTING_TOOL_CALL":
      return ExecutionStatusType.EXECUTING_TOOL_CALL;
    case 3:
    case "ERROR_STATE":
      return ExecutionStatusType.ERROR_STATE;
    case 4:
    case "SUCCESS":
      return ExecutionStatusType.SUCCESS;
    case 5:
    case "VALIDATING_TOOL_CALL":
      return ExecutionStatusType.VALIDATING_TOOL_CALL;
    case 6:
    case "TOOL_CALL_SUCCESS":
      return ExecutionStatusType.TOOL_CALL_SUCCESS;
    case 7:
    case "TOOL_CALL_FAILURE":
      return ExecutionStatusType.TOOL_CALL_FAILURE;
    case 8:
    case "BUILDING_DATAFRAME":
      return ExecutionStatusType.BUILDING_DATAFRAME;
    case 9:
    case "VALIDATING_DATAFRAME":
      return ExecutionStatusType.VALIDATING_DATAFRAME;
    case 10:
    case "EXECUTING_DATAFRAME":
      return ExecutionStatusType.EXECUTING_DATAFRAME;
    case 11:
    case "FETCHING_PAST_JOB_RUNS":
      return ExecutionStatusType.FETCHING_PAST_JOB_RUNS;
    case 12:
    case "FETCHING_SCENARIO_DETAIL":
      return ExecutionStatusType.FETCHING_SCENARIO_DETAIL;
    case 13:
    case "LOADING_SCENARIO_MANAGEMENT_SKILL":
      return ExecutionStatusType.LOADING_SCENARIO_MANAGEMENT_SKILL;
    case 14:
    case "LOADING_SCENARIO_SYNTHESIS_SKILL":
      return ExecutionStatusType.LOADING_SCENARIO_SYNTHESIS_SKILL;
    case 15:
    case "UPDATING_SCENARIO_METADATA":
      return ExecutionStatusType.UPDATING_SCENARIO_METADATA;
    case 16:
    case "BUILDING_KG_OBSERVATION":
      return ExecutionStatusType.BUILDING_KG_OBSERVATION;
    case 17:
    case "EXECUTING_KG_OBSERVATION":
      return ExecutionStatusType.EXECUTING_KG_OBSERVATION;
    case 18:
    case "SAVING_SCENARIO":
      return ExecutionStatusType.SAVING_SCENARIO;
    case 19:
    case "BUILDING_ANALYSIS_OUTPUT":
      return ExecutionStatusType.BUILDING_ANALYSIS_OUTPUT;
    case 20:
    case "FETCHING_ANALYSIS_OUTPUT":
      return ExecutionStatusType.FETCHING_ANALYSIS_OUTPUT;
    case 21:
    case "ANALYZING_DATAFRAMES":
      return ExecutionStatusType.ANALYZING_DATAFRAMES;
    case 22:
    case "CREATING_DATAFRAME_ANALYSIS":
      return ExecutionStatusType.CREATING_DATAFRAME_ANALYSIS;
    case 23:
    case "EXECUTING_DATAFRAME_ANALYSIS":
      return ExecutionStatusType.EXECUTING_DATAFRAME_ANALYSIS;
    case 24:
    case "LOADING_SKILL":
      return ExecutionStatusType.LOADING_SKILL;
    case 25:
    case "BUILDING_CHART":
      return ExecutionStatusType.BUILDING_CHART;
    case 26:
    case "CREATING_SCENARIO_METADATA":
      return ExecutionStatusType.CREATING_SCENARIO_METADATA;
    case 27:
    case "BUILDING_REPORT":
      return ExecutionStatusType.BUILDING_REPORT;
    case 28:
    case "REASONING_SUMMARY":
      return ExecutionStatusType.REASONING_SUMMARY;
    case 29:
    case "CREATING_FILE_ARTIFACT":
      return ExecutionStatusType.CREATING_FILE_ARTIFACT;
    case 30:
    case "SEARCHING_WORKFLOW_RUNS":
      return ExecutionStatusType.SEARCHING_WORKFLOW_RUNS;
    case 31:
    case "SAVING_WORKFLOW_RUN":
      return ExecutionStatusType.SAVING_WORKFLOW_RUN;
    case 32:
    case "LOADING_WORKFLOW_RUN":
      return ExecutionStatusType.LOADING_WORKFLOW_RUN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ExecutionStatusType.UNRECOGNIZED;
  }
}

export function executionStatusTypeToJSON(object: ExecutionStatusType): string {
  switch (object) {
    case ExecutionStatusType.IDLE_STATE:
      return "IDLE_STATE";
    case ExecutionStatusType.EXECUTING_LLM_CALL:
      return "EXECUTING_LLM_CALL";
    case ExecutionStatusType.EXECUTING_TOOL_CALL:
      return "EXECUTING_TOOL_CALL";
    case ExecutionStatusType.ERROR_STATE:
      return "ERROR_STATE";
    case ExecutionStatusType.SUCCESS:
      return "SUCCESS";
    case ExecutionStatusType.VALIDATING_TOOL_CALL:
      return "VALIDATING_TOOL_CALL";
    case ExecutionStatusType.TOOL_CALL_SUCCESS:
      return "TOOL_CALL_SUCCESS";
    case ExecutionStatusType.TOOL_CALL_FAILURE:
      return "TOOL_CALL_FAILURE";
    case ExecutionStatusType.BUILDING_DATAFRAME:
      return "BUILDING_DATAFRAME";
    case ExecutionStatusType.VALIDATING_DATAFRAME:
      return "VALIDATING_DATAFRAME";
    case ExecutionStatusType.EXECUTING_DATAFRAME:
      return "EXECUTING_DATAFRAME";
    case ExecutionStatusType.FETCHING_PAST_JOB_RUNS:
      return "FETCHING_PAST_JOB_RUNS";
    case ExecutionStatusType.FETCHING_SCENARIO_DETAIL:
      return "FETCHING_SCENARIO_DETAIL";
    case ExecutionStatusType.LOADING_SCENARIO_MANAGEMENT_SKILL:
      return "LOADING_SCENARIO_MANAGEMENT_SKILL";
    case ExecutionStatusType.LOADING_SCENARIO_SYNTHESIS_SKILL:
      return "LOADING_SCENARIO_SYNTHESIS_SKILL";
    case ExecutionStatusType.UPDATING_SCENARIO_METADATA:
      return "UPDATING_SCENARIO_METADATA";
    case ExecutionStatusType.BUILDING_KG_OBSERVATION:
      return "BUILDING_KG_OBSERVATION";
    case ExecutionStatusType.EXECUTING_KG_OBSERVATION:
      return "EXECUTING_KG_OBSERVATION";
    case ExecutionStatusType.SAVING_SCENARIO:
      return "SAVING_SCENARIO";
    case ExecutionStatusType.BUILDING_ANALYSIS_OUTPUT:
      return "BUILDING_ANALYSIS_OUTPUT";
    case ExecutionStatusType.FETCHING_ANALYSIS_OUTPUT:
      return "FETCHING_ANALYSIS_OUTPUT";
    case ExecutionStatusType.ANALYZING_DATAFRAMES:
      return "ANALYZING_DATAFRAMES";
    case ExecutionStatusType.CREATING_DATAFRAME_ANALYSIS:
      return "CREATING_DATAFRAME_ANALYSIS";
    case ExecutionStatusType.EXECUTING_DATAFRAME_ANALYSIS:
      return "EXECUTING_DATAFRAME_ANALYSIS";
    case ExecutionStatusType.LOADING_SKILL:
      return "LOADING_SKILL";
    case ExecutionStatusType.BUILDING_CHART:
      return "BUILDING_CHART";
    case ExecutionStatusType.CREATING_SCENARIO_METADATA:
      return "CREATING_SCENARIO_METADATA";
    case ExecutionStatusType.BUILDING_REPORT:
      return "BUILDING_REPORT";
    case ExecutionStatusType.REASONING_SUMMARY:
      return "REASONING_SUMMARY";
    case ExecutionStatusType.CREATING_FILE_ARTIFACT:
      return "CREATING_FILE_ARTIFACT";
    case ExecutionStatusType.SEARCHING_WORKFLOW_RUNS:
      return "SEARCHING_WORKFLOW_RUNS";
    case ExecutionStatusType.SAVING_WORKFLOW_RUN:
      return "SAVING_WORKFLOW_RUN";
    case ExecutionStatusType.LOADING_WORKFLOW_RUN:
      return "LOADING_WORKFLOW_RUN";
    case ExecutionStatusType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Darwin Header */
export interface DarwinHeader {
  /** Base header fields */
  id?: string | undefined;
  name?: string | undefined;
  description?: string | undefined;
  type?: string | undefined;
  is_active?: boolean | undefined;
  version?:
    | number
    | undefined;
  /** whether if it is response tool or not */
  is_response_tool?:
    | boolean
    | undefined;
  /** Timestamp fields in ms */
  created_date?: number | undefined;
  last_modified_date?:
    | number
    | undefined;
  /** whether the entity is hidden (default: false) */
  is_hidden?:
    | boolean
    | undefined;
  /** Unique identifier of the user who created this entity */
  author_id?: string | undefined;
}

export interface DarwinHeaderList {
  /** List of headers */
  headers: DarwinHeader[];
  /** total items for the response */
  total?: number | undefined;
}

function createBaseDarwinHeader(): DarwinHeader {
  return {
    id: undefined,
    name: undefined,
    description: undefined,
    type: undefined,
    is_active: undefined,
    version: undefined,
    is_response_tool: undefined,
    created_date: undefined,
    last_modified_date: undefined,
    is_hidden: undefined,
    author_id: undefined,
  };
}

export const DarwinHeader: MessageFns<DarwinHeader> = {
  encode(message: DarwinHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== undefined) {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.type !== undefined) {
      writer.uint32(34).string(message.type);
    }
    if (message.is_active !== undefined) {
      writer.uint32(40).bool(message.is_active);
    }
    if (message.version !== undefined) {
      writer.uint32(48).int32(message.version);
    }
    if (message.is_response_tool !== undefined) {
      writer.uint32(56).bool(message.is_response_tool);
    }
    if (message.created_date !== undefined) {
      writer.uint32(64).int64(message.created_date);
    }
    if (message.last_modified_date !== undefined) {
      writer.uint32(72).int64(message.last_modified_date);
    }
    if (message.is_hidden !== undefined) {
      writer.uint32(80).bool(message.is_hidden);
    }
    if (message.author_id !== undefined) {
      writer.uint32(90).string(message.author_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DarwinHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDarwinHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.is_active = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.version = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.is_response_tool = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.created_date = longToNumber(reader.int64());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.last_modified_date = longToNumber(reader.int64());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.is_hidden = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.author_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DarwinHeader {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      type: isSet(object.type) ? globalThis.String(object.type) : undefined,
      is_active: isSet(object.is_active) ? globalThis.Boolean(object.is_active) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : undefined,
      is_response_tool: isSet(object.is_response_tool) ? globalThis.Boolean(object.is_response_tool) : undefined,
      created_date: isSet(object.created_date) ? globalThis.Number(object.created_date) : undefined,
      last_modified_date: isSet(object.last_modified_date) ? globalThis.Number(object.last_modified_date) : undefined,
      is_hidden: isSet(object.is_hidden) ? globalThis.Boolean(object.is_hidden) : undefined,
      author_id: isSet(object.author_id) ? globalThis.String(object.author_id) : undefined,
    };
  },

  toJSON(message: DarwinHeader): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.type !== undefined) {
      obj.type = message.type;
    }
    if (message.is_active !== undefined) {
      obj.is_active = message.is_active;
    }
    if (message.version !== undefined) {
      obj.version = Math.round(message.version);
    }
    if (message.is_response_tool !== undefined) {
      obj.is_response_tool = message.is_response_tool;
    }
    if (message.created_date !== undefined) {
      obj.created_date = Math.round(message.created_date);
    }
    if (message.last_modified_date !== undefined) {
      obj.last_modified_date = Math.round(message.last_modified_date);
    }
    if (message.is_hidden !== undefined) {
      obj.is_hidden = message.is_hidden;
    }
    if (message.author_id !== undefined) {
      obj.author_id = message.author_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DarwinHeader>, I>>(base?: I): DarwinHeader {
    return DarwinHeader.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DarwinHeader>, I>>(object: I): DarwinHeader {
    const message = createBaseDarwinHeader();
    message.id = object.id ?? undefined;
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    message.type = object.type ?? undefined;
    message.is_active = object.is_active ?? undefined;
    message.version = object.version ?? undefined;
    message.is_response_tool = object.is_response_tool ?? undefined;
    message.created_date = object.created_date ?? undefined;
    message.last_modified_date = object.last_modified_date ?? undefined;
    message.is_hidden = object.is_hidden ?? undefined;
    message.author_id = object.author_id ?? undefined;
    return message;
  },
};

function createBaseDarwinHeaderList(): DarwinHeaderList {
  return { headers: [], total: undefined };
}

export const DarwinHeaderList: MessageFns<DarwinHeaderList> = {
  encode(message: DarwinHeaderList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.headers) {
      DarwinHeader.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.total !== undefined) {
      writer.uint32(16).int32(message.total);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DarwinHeaderList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDarwinHeaderList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.headers.push(DarwinHeader.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.total = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DarwinHeaderList {
    return {
      headers: globalThis.Array.isArray(object?.headers)
        ? object.headers.map((e: any) => DarwinHeader.fromJSON(e))
        : [],
      total: isSet(object.total) ? globalThis.Number(object.total) : undefined,
    };
  },

  toJSON(message: DarwinHeaderList): unknown {
    const obj: any = {};
    if (message.headers?.length) {
      obj.headers = message.headers.map((e) => DarwinHeader.toJSON(e));
    }
    if (message.total !== undefined) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DarwinHeaderList>, I>>(base?: I): DarwinHeaderList {
    return DarwinHeaderList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DarwinHeaderList>, I>>(object: I): DarwinHeaderList {
    const message = createBaseDarwinHeaderList();
    message.headers = object.headers?.map((e) => DarwinHeader.fromPartial(e)) || [];
    message.total = object.total ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
